/**
 * トップページ: 特集セクション
 */

import { waitForImagesLoad, adjustSlideButtonPosition } from '../utils';

/**
 * 特集セクションの初期化
 * @param {jQuery} $ - jQuery
 */
export function initFeatures($) {
  const $mainSlide = $('.s-home__features-slide--main');
  const $thumbSlide = $('.s-home__features-slide--thumbnails');
  const $lcpImage = $('.s-home__features-lcp-image');

  if ($mainSlide.length === 0) return;

  // ボタン位置調整関数
  function adjustButtonPosition() {
    adjustSlideButtonPosition($mainSlide, '.c-slide__item', '.s-home__card-figure', { useTransform: true });
  }

  // LCP画像を非表示にする関数
  function hideLcpImage() {
    if ($lcpImage.length > 0) {
      $lcpImage.addClass('is-hidden');
    }
  }

  // メイン画像スライダー
  $mainSlide
    .on('init', function () {
      // Slick初期化完了時にLCP画像を非表示
      hideLcpImage();
      setTimeout(adjustButtonPosition, 100);
    })
    .slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      arrows: true,
      dots: false,
      asNavFor: '.s-home__features-slide--thumbnails',
      fade: true,
      autoplay: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            fade: false,
          },
        },
      ],
    });

  // サムネイルスライダー
  $thumbSlide.slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    arrows: true,
    dots: false,
    asNavFor: '.s-home__features-slide--main',
    focusOnSelect: true,
    vertical: true,
    verticalSwiping: true,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 4,
          vertical: false,
          verticalSwiping: false,
        },
      },
      {
        breakpoint: 696,
        settings: {
          vertical: false,
          verticalSwiping: false,
        },
      },
    ],
  });

  // 画像読み込み完了後に位置調整
  const $images = $mainSlide.find('.s-home__card-figure img');
  waitForImagesLoad($images, adjustButtonPosition);

  return { adjustButtonPosition };
}
